import React, {useEffect, useState} from "react";
import { useSnackbar } from 'notistack';
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ConfirmDialog from "../ConfirmDialog";
import {useDeleteDismantleMutation} from "../../services/authService";
import messages from "../../utils/messages";
import {SETUP_DISMANTLE} from "../../utils/constants";
import styles from "./SetupDismantle.module.scss";

const DeleteSetupDismantle = ({ type, id, onDelete }) => {
    const [open, setOpen] = useState(false);
    const [deleteDismantle, { isSuccess, error, reset }] = useDeleteDismantleMutation();
    const { enqueueSnackbar } = useSnackbar();

    const handleOpen = () => {
        setOpen(true);
    }

    const handleDelete = () => {
        console.log('id');
        deleteDismantle(id);
    }

    const handleMessages = () => {
        if(isSuccess){
            enqueueSnackbar(
                type === SETUP_DISMANTLE.setup  ? `${messages.success.deleteSetup}` : `${messages.success.deleteDismantle}`,
                { variant: 'success' }
            );
            reset();
            onDelete();
        }
        if(error){
            enqueueSnackbar(`${messages.error.prefix} ${error?.data[0]?.errorMessage}`, { variant: 'error' });
        }
    }

    useEffect(() => {
        if(isSuccess || error){
            handleMessages();
        }
        // eslint-disable-next-line
    }, [isSuccess, error]);

    return (
        <>
            <DeleteOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon}`}
            />
            <ConfirmDialog
                title={`Delete ${type}`}
                open={open}
                setOpen={setOpen}
                onConfirm={handleDelete}
            >
                { type === SETUP_DISMANTLE.setup ? messages.confirm.deleteSetup : messages.confirm.deleteDismantle}
            </ConfirmDialog>
        </>
    )
}

export default DeleteSetupDismantle;
